import { render, staticRenderFns } from "./priceHistChart.vue?vue&type=template&id=40df70f3&scoped=true&"
import script from "./priceHistChart.vue?vue&type=script&lang=js&"
export * from "./priceHistChart.vue?vue&type=script&lang=js&"
import style0 from "./priceHistChart.vue?vue&type=style&index=0&id=40df70f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df70f3",
  null
  
)

export default component.exports